const getTokenLogoURL = (address: string) =>
  //  `/images/tokens/${address}.png`
  `https://images.lorachain.org/images/${address}.png`
// `https://assets.trustwalletapp.com/blockchains/smartchain/assets/${address}/logo.png`

export default getTokenLogoURL
